const legacyCallDeviceIdStorageKeys = ['jema.calls.device-id'];

let transientCallDeviceId: string | null = null;

const createCallDeviceId = () => {
  const randomUUID = globalThis.crypto?.randomUUID;
  if (typeof randomUUID === 'function') {
    return randomUUID.call(globalThis.crypto);
  }

  return `call-device-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
};

// Deliberately in-memory only, not sessionStorage/localStorage: a device id
// tied to a Telnyx SIP credential can be left with a stuck/conflicting
// registration (486 user_busy) after a bad call, network drop, or crash.
// sessionStorage survives a hard refresh — reusing the same id there just
// reconnects to the same broken registration. Keeping it in memory means
// every real page load (refresh, not just a fresh tab) gets a brand new id,
// and therefore a brand new Telnyx credential — a guaranteed-clean identity
// every time, without needing an incognito window. Repeat calls within one
// page load still reuse the same id/credential. Orphaned per-load
// credentials are reaped by processStaleStaffWebRtcCredentialCleanup.
export function getCallDeviceId() {
  transientCallDeviceId ??= createCallDeviceId();

  if (typeof window !== 'undefined') {
    try {
      legacyCallDeviceIdStorageKeys.forEach(key => {
        window.sessionStorage.removeItem(key);
        window.localStorage.removeItem(key);
      });
    } catch {
      // Storage access can throw (private mode, disabled storage) — harmless.
    }
  }

  return transientCallDeviceId;
}
